import api from '../../../api';
import { finish, error } from '../../../modules/staff/actions/get';

export function request(dispatch) {
    api.get('/staff').then(
        data => dispatch(finish(data)),
        ({ errors }) => dispatch(error(errors))
    );
}
